import React, { useEffect } from 'react';
import ConsentGuard from './ConsentGuard';

// Entfernt Skript und globale mt*-Variablen des Widgets, damit es bei jedem Besuch neu initialisiert.
// remove() statt removeChild(): wirft nicht, wenn das Skript schon entfernt wurde (StrictMode, Seitenwechsel).
const removeMetarScript = () => {
  document.querySelectorAll('script[src*="metar-taf.com"]').forEach((script) => script.remove());
  const globalObj = window as any;
  Object.keys(globalObj).forEach((key) => {
    if (key.startsWith('mt')) {
      delete globalObj[key];
    }
  });
};

const MetarWidgetContent: React.FC = () => {
  useEffect(() => {
    // Reste eines früheren Besuchs entfernen, dann das METAR-Skript laden
    removeMetarScript();
    const script = document.createElement('script');
    script.src = 'https://metar-taf.com/embed-js/EDEB?qnh=hPa&rh=rh&target=aal5NdeK';
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';

    document.body.appendChild(script);

    return removeMetarScript;
  }, []);

  return (
    <div className="mt-4 mb-10 mx-auto" style={{ maxWidth: '300px' }}>
      <a 
        href="https://metar-taf.com/metar/EDEB" 
        id="metartaf-aal5NdeK" 
        style={{
          fontSize: '18px',
          fontWeight: 500,
          color: '#000',
          width: '300px',
          height: '435px',
          display: 'block'
        }}
      >
        METAR Bad Langensalza Airfield
      </a>
    </div>
  );
};

const MetarWidget: React.FC = () => {
  return (
    <ConsentGuard title="METAR Wetter-Daten">
      <MetarWidgetContent />
    </ConsentGuard>
  );
};

export default MetarWidget;
